import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';

export default function DataTable({ rows, columns }) {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        overflowX: 'auto',
        mt: 1,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        scrollbarSize={0}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            maxHeight: 'none',
            minHeight: '56px',
          },
          '& .MuiDataGrid-columnHeader': {
            lineHeight: '1.2',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            backgroundColor: '#F0F0F0',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
            fontSize: '1rem',
            whiteSpace: 'normal',
            lineHeight: '1.2',
            textAlign: 'center',
          },
          '& .MuiDataGrid-cell:focus': {
            outline: 'none !important',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none !important',
          },
          '& .MuiDataGrid-row.Mui-selected': {
            backgroundColor: 'transparent !important',
          },
        }}
        components={{
          ColumnMenu: () => null,
        }}
        initialState={{
          sorting: {
            sortModel: [{ field: 'id', sort: 'desc' }],
          },
          pagination: {
            paginationModel: { page: 0, pageSize: 50 },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        disableRowSelectionOnClick
      />
    </Box>
  );
}